import angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';

import { FeaturedEventsComponent } from './featured-events.component';

export default angular
    .module('control-room.events.components.featured-events', [])
    .directive('crFeaturedEvents', downgradeComponent({ component: FeaturedEventsComponent }));
